import axiosClient from "../axios/axiosClient";

export function getResearchCentres() {
  return axiosClient.get("/research-centres");
}

export function getResearchCentre(researchCentreId) {
  return axiosClient.get(`/research-centres/${researchCentreId}`);
}

export function createResearchCentre(data) {
  return axiosClient.post("/research-centres", data);
}

export const updateResearchCentre = (researchCentreId, data) => {
  return axiosClient.put(`/research-centres/${researchCentreId}`, data);
};

export function deleteResearchCentre(researchCentreId) {
  return axiosClient.delete(`/research-centres/${researchCentreId}`);
}
